import RemainingBudgetCard from './RemainingBudgetCard';

export default RemainingBudgetCard;
